<template>
  <div class="all-height all-width" data-testid="gl-list">
    <div class="">
      <v-card loader-height="2" class="shadow-off" :loading="loading" :disabled="loading" data-testid="gl-list__card">
        <v-card-text class="">
          <div>
            <h3 class="font-weight-medium mb-2" data-testid="gl-list__title">{{ $nova.labelsName('gllist_page', 'threshold_label', 'GL List') }}</h3>
            <div class="d-flex">
              <div class="d-flex align-center pb-4">
                <h2 class="font-weight-medium" data-testid="gl-list__total-count">{{ allgls.length }}</h2>
                <span class="ml-2 line-1">Total<br />Count</span>
              </div>
              <v-spacer></v-spacer>
              <v-btn class="shadow-off" icon @click="refreshData()" data-testid="gl-list__refresh-btn"><v-icon>mdi-refresh</v-icon></v-btn>
            </div>

            <div class="d-flex">
              <div class="pb-4">
                <div>Below is the list of all the GL's in this application.</div>
                <div>You can define the order in which the GL's have to be displayed here.</div>
              </div>
              <v-spacer></v-spacer>
              <div class="text-right" v-if="pendingchange" data-testid="gl-list__pending-changes">
                <div><v-btn class="shadow-off" color="primary" @click="saveData()" data-testid="gl-list__save-btn"><v-icon
                      class="mr-1">mdi-content-save</v-icon><span>Save changes</span></v-btn></div>
                <div class="error--text">Few changes are yet to be saved</div>
              </div>
            </div>
            <v-simple-table dense height="70vh" class="v-table-color" fixed-header id="exceltable"
              v-if="visibleItems.length > 0" data-testid="gl-list__table">
              <thead class="tableHeaderBg">
                <tr class="v-table-color">
                  <th class="text-left font-weight-bold">Nav</th>
                  <th class="text-left font-weight-bold">Code</th>
                  <th class="text-left font-weight-bold">Name</th>
                  <th class="text-left font-weight-bold noTransform">GL's</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(v, k) in visibleItems" :key="v._id" draggable="true" @dragstart="dragStart(k)"
                  @dragover.prevent="dragOver(k)" @dragenter.prevent @drop="drop(k)" :style="{
                    fontWeight: v.level === 0 ? 'bold' : 'normal',
                    backgroundColor: v.level === 0 ? '#f5f5f5' : 'transparent',
                  }" class="tree-table" :class="{ 'drag-over': dragOverIndex === k }" data-testid="gl-list__table-row">
                  <td @click="toggleExpand(v)">
                    <div class="tree-label d-flex align-center" :style="{ paddingLeft: `${v.level * 10}px` }">
                      <div class="node-container">
                        <span class="node-label" :class="'childlevele-' + v.level"></span>
                      </div>
                      <div>
                        <span v-if="hasChildren(v)" class="expand-icon" data-testid="gl-list__expand-icon">
                          <v-icon>
                            {{
                              isExpanded(v) ? "mdi-minus-box" : "mdi-plus-box"
                            }}
                          </v-icon>
                        </span>
                        <span v-else class="no-children-spacer"></span>
                      </div>
                    </div>
                  </td>
                  <td class="text-left">{{ v.code }}</td>
                  <td class="text-left">{{ v.name }}</td>
                  <td class="text-left">
                    <div class="d-flex align-center">
                      <!-- GL Chips -->
                      <v-chip v-if="v.glnew" label color="info" class="white--text px-2" data-testid="gl-list__new-chip"><span>New</span></v-chip>
                      <v-chip label color="primary" class="white--text px-2 ml-2" data-testid="gl-list__count-chip">
                        <v-chip small color="white" class="mr-2 px-2 ">{{ v.subsequent_children?.length || "-"
                        }}</v-chip><span class="noTransform">
                        {{ $nova.labelsName("gl_selection", "commentary_gl_shortform_label", "GL") }}'s</span>
                      </v-chip>
                      
                      <!-- Drag Button (with consistent alignment) -->
                      <v-tooltip bottom content-class="tooltip-bottom">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn class="drag-handle ml-2" icon v-bind="attrs" v-on="on" @mousedown.stop
                            @touchstart.stop data-testid="gl-list__drag-btn">
                            <v-icon large>mdi-drag</v-icon>
                          </v-btn>
                        </template>
                        <span>Drag To Reorder</span>
                      </v-tooltip>
                    </div>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
            <div v-else class="title grey--text pa-5 text-center" data-testid="gl-list__no-data">
              No Data Found
            </div>




            
          </div>
          <lb-dialog v-model="glgroupingdialog" :loading="glgroupingloading" heading="Group GL" width="500" data-testid="gl-list__grouping-dialog">
            <template v-slot:body>
              <div>
                <div class="mb-4">
                  <div class="font-size-md mb-2">{{ glgroupingselected.code }} - {{ glgroupingselected.name }}</div>
                  <div class="">Select whether this GL should become the Parent(primary) or it should form part of an
                    existing parent GL</div>
                </div>
                <lb-dropdown hidedetails label="Select Parent" v-model="selectedparent"
                  :items="getParentListForChange()" itemtext="text" itemvalue="value" data-testid="gl-list__parent-dropdown" />
              </div>
            </template>
            <template v-slot:actions>
              <v-spacer></v-spacer>
              <v-btn v-if="selectedparent !== glgroupingselected.parent" @click="changeParent()" color="success"
                class="ml-2" data-testid="gl-list__change-parent-btn"><span>Change</span></v-btn>
            </template>
          </lb-dialog>
        </v-card-text>
      </v-card>

    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: 'GLListWithNavigation',
  data: function () {
    return {
      loading: false,
      allgls: [],
      data: [],
      expandedgls: [],
      gllist: {},
      selectedgls: [],
      unapprovedrequest: [],
      pendingchange: false,
      // pendingdialog: false,
      // pendinggllist: {},
      glgroupingselected: {},
      glgroupingdialog: false,
      glgroupingloading: false,
      selectedparent: null,
      isNewList: false,
      getResult: [],
      finalResult: [],
      expandedIds: [],
      dragItemIndex: null,
      dragOverIndex: null,
    }
  },
  activated() {
    this.refreshData();
  },
  mounted() {
    this.refreshData();
  },

  methods: {
    ...mapActions("varianceanalysis/gllist", ["getGLList", "saveGLOrder"]),
    updateOrder() {
      const nodeMap = {};
      this.getResult.forEach((node) => {
        nodeMap[node.code] = node;
      });
      const rootNodes = this.getResult.filter(
        (node) => node.parent === "primary" || !nodeMap[node.parent]
      );
      
      // We must sort rootNodes based on the CURRENT order values before re-indexing
      rootNodes.sort((a, b) => a.order - b.order);

      let currentOrder = 1;
      function traverse(node) {
        node.order = currentOrder++;
        if (node.children && node.children.length > 0) {
          // Sort children by their current order value (which we just updated for the dragged item)
          node.children.sort((a, b) => {
             const nodeA = nodeMap[a];
             const nodeB = nodeMap[b];
             if (!nodeA || !nodeB) return 0;
             return nodeA.order - nodeB.order;
          });
          
          node.children.forEach((childCode) => {
            const childNode = nodeMap[childCode];
            if (childNode) {
              traverse(childNode);
            }
          });
        }
      }
      
      rootNodes.forEach((root) => traverse(root));
    },
    dragStart(index) {
      this.dragItemIndex = index;
    },

    dragOver(index) {
      this.dragOverIndex = index;
    },

    drop(index) {
      this.dragOverIndex = index;
      const draggedIndex = this.dragItemIndex;
      const targetIndex = index;
      
      const draggedItem = this.visibleItems[draggedIndex];
      const targetItem = this.visibleItems[targetIndex];

      // Allow moving between 'primary' and 'NA' (Ungrouped)
      const allowedParents = ['primary', 'NA', null];
      const isDraggedPrimaryOrNA = allowedParents.includes(draggedItem.parent);
      const isTargetPrimaryOrNA = allowedParents.includes(targetItem.parent);
      
      const isCrossParentMove = (draggedItem.parent !== targetItem.parent) && (isDraggedPrimaryOrNA && isTargetPrimaryOrNA);

      if (draggedItem.level !== targetItem.level && !isCrossParentMove) {
        this.$store.commit("sbError", "Cannot change hierarchy level with drag and drop");
        return;
      }
      
      // Also ensure they have the same parent, otherwise we are moving between parents which might not be supported
      // efficiently by just changing 'order'. Changing parent requires changing 'parent' field.
      // The current UI seems to support reordering within same list.

      // Find the item in the full list (getResult) to update its order
      let findorder = this.getResult.find(
        (item) => item.code === draggedItem.code
      );

      if (!findorder) {
          return;
      }

      if (draggedItem.parent !== targetItem.parent) {
           // If both are not in the allowed 'primary'/'NA' set, then block
           if (!(isDraggedPrimaryOrNA && isTargetPrimaryOrNA)) {
               this.$store.commit("sbError", "Cannot move items between different parents via drag and drop");
               return;
           }
           
           // If we are here, it means we are moving between primary and NA.
           // We need to update the parent of the dragged item to match the target.
           if (findorder) {
                // If moving from Primary to NA, set parent to 'NA'
                // And we must update 'path' to ensure UI reflects correctly (level, etc) if path is used for level calculation
                // However, without server response, we can't truly update path fully correctly if it's complex.
                // But for Primary/NA which are root level things usually:
                // Primary path: [code]
                // NA path: [NA, code]
                // Let's try to simulate path update for immediate UI feedback.
                
                if (isTargetPrimaryOrNA && targetItem.parent === 'NA') {
                     findorder.parent = 'NA';
                     // Simulate path update for level recalculation in next flattenTree
                     // findorder.path = ['NA', findorder.code]; // This might be risky if path structure is different.
                     // But let's assume standard structure.
                } else if (isTargetPrimaryOrNA && (targetItem.parent === 'primary' || !targetItem.parent)) {
                     // If moving from NA to Primary, set parent to 'primary'
                     findorder.parent = 'primary';
                     // findorder.path = [findorder.code];
                } else {
                     findorder.parent = targetItem.parent || 'primary';
                }
           }
      } else {
          // If moving within same parent scope, we don't need to change parent, only order.
      }

      // Logic for reordering...
      let newOrder;

      // Logic: Insert BEFORE the target item typically.
      // But if dragging down, we want it to be AT target index, which means after the previous item at that visual slot? 
      // If we insert 'before' target, then target shifts down.
      // E.g. A, B, C. Drag A to C.
      // Target C. Insert before C? -> B, A, C.
      // But user usually drags to "C" slot intending to swapping or placing there.
      // If we assume "insert before":
      // A (0) to C (2).
      // Insert A before C. -> B, A, C.
      // Order of A should be between B and C.
      
      // If we assume "insert after" (if dragging down):
      // A (0) to C (2).
      // Order of A > C. -> B, C, A.

      // Standard UX:
      // Dragging down: Drop target is the item *below* where we want to be? OR drop target is the slot we take.
      // If I drag A onto B (below it). I expect A to be between B and its successor? Or swap?
      
      // If moving cross-parent, insertion rules are slightly simpler: just put it next to target.
      
      if (draggedIndex < targetIndex || isCrossParentMove) {
        // Dragging DOWN or Moving to DIFFERENT group -> Insert AFTER target typically if dragging down?
        // But if cross parent, draggedIndex and targetIndex are just linear indices in filtered list.
        // If I drag from top (0) to bottom (10), index < targetIndex.
        // If I drag from bottom (NA group) to top (Primary), index > targetIndex.
        
        // If moving TO NA (from Primary), draggedIndex < targetIndex usually (Primary is above NA).
        // If moving TO Primary (from NA), draggedIndex > targetIndex usually.
        
        const draggingDown = draggedIndex < targetIndex;
        
        if (draggingDown) {
             // Place AFTER target
             let nextItem = null;
             if (targetIndex < this.visibleItems.length - 1) {
                  nextItem = this.visibleItems[targetIndex + 1];
             }
             
             // If we are at the edge of a group (e.g. last item of Primary, and next is NA header/item),
             // and we are dragging into Primary, nextItem might be NA group header/item.
             // We should check if nextItem belongs to same parent as target.
             if (nextItem && nextItem.parent !== targetItem.parent) {
                  nextItem = null; // Treat as end of list for THIS group
             }

             if (nextItem) {
                 if (nextItem.level === targetItem.level) { // Compare against target level, not dragged (since dragged might be diff level initially)
                     newOrder = (targetItem.order + nextItem.order) / 2;
                 } else {
                     newOrder = targetItem.order + 0.1;
                 }
             } else {
                 newOrder = targetItem.order + 0.5;
             }
        } else {
             // Dragging UP (or cross parent UP) -> Insert BEFORE target
             let prevItem = null;
             if (targetIndex > 0) {
                 prevItem = this.visibleItems[targetIndex - 1];
             }
             
             // Check if prevItem belongs to same parent
             if (prevItem && prevItem.parent !== targetItem.parent) {
                  prevItem = null; // Start of list for THIS group
             }

             if (prevItem) {
                  if (prevItem.level === targetItem.level) {
                      newOrder = (prevItem.order + targetItem.order) / 2;
                  } else {
                      newOrder = targetItem.order - 0.1;
                  }
             } else {
                  newOrder = targetItem.order - 0.1;
             }
        }

      } else {
        // Dragging UP within same group
        let prevItem = null;
        if (targetIndex > 0) {
            prevItem = this.visibleItems[targetIndex - 1];
        }

        if (prevItem) {
             if (prevItem.level === draggedItem.level) {
                 newOrder = (prevItem.order + targetItem.order) / 2;
             } else {
                 newOrder = targetItem.order - 0.1;
             }
        } else {
             newOrder = targetItem.order - 0.5;
        }
      }

      findorder.order = newOrder;
      
      this.updateOrder();

      // Trigger reactivity for visibleItems as getResult mutation might not trigger it if array ref is same
      this.getResult = [...this.getResult];
      this.pendingchange = true; // Ensure pendingchange is true at the end of drop

      this.finalResult = this.getResult.map(item => ({
        _id: item._id,
        code: item.code,
        parent: item.parent,
        order: item.order
      }));
      // console.log(this.finalResult, "finalResult");

    },
    flattenTree(nodes) {
      let ungroupedGLs = [];
      let ungroupedGLsChildren = [];
      let result = [];
      
      // Clone nodes to avoid mutating original array sorting order if it matters elsewhere
      // But updateOrder relies on nodes being sorted? No, updateOrder re-sorts.
      // Here we sort for display.
      const sortedNodes = [...nodes].sort((a, b) => a.order - b.order);

      for (const node of sortedNodes) {
        // Create a shallow copy for display purposes to avoid mutating original state
        const displayNode = { ...node };

        // We have ungrouped GLs
        if (displayNode.parent === "NA" || displayNode?.path?.includes("NA")) {
          ungroupedGLs.push(displayNode?.code);
          ungroupedGLsChildren.push(displayNode?.code, ...displayNode?.children || []);
          if (displayNode?.order < this.$constants.UNGROUPED_GL_OFFSET) {
            displayNode.oldOrder = displayNode?.order
            displayNode.order += this.$constants.UNGROUPED_GL_OFFSET;
          }
        }
        const createdAt = new Date(displayNode.created_at);
        const now = new Date();
        const diffDays = (now - createdAt) / (1000 * 60 * 60 * 24);
        const isGlnew = diffDays <= 60;
        result.push({
          ...displayNode,
          level: displayNode.path?.length - 1 || 0,
          glnew: isGlnew,
        });
      }
      if (ungroupedGLs?.length) {
        let NANode = {
          name: "Ungrouped: Other sub-schedules and further Analysis Accounts",
          code: "NA",
          children: ungroupedGLs,
          subsequent_children: ungroupedGLsChildren,
          order: this.$constants.UNGROUPED_GL_OFFSET,
        };
        result.push({
          ...NANode,
          level: NANode?.path?.length - 1 || 0,
          glnew: false,
        });
        
        // Ensure NA node is expanded initially if not already
        if(!this.expandedIds.includes("NA")) {
             // We shouldn't mutate state here ideally, but if we must ensuring it's visible:
             // Better to do this initialization in mounted/data load. 
             // Leaving this out to prevent side effects.
        }
      }
      result = result.sort((a, b) => a.order - b.order);
      return result;
    },
    toggleExpand(item) {
      if (!this.hasChildren(item)) return;
      let childarray = item.children;
      let subchild = item.subsequent_children;
      if (this.expandedIds.includes(childarray[0])) {
        this.expandedIds = this.expandedIds.filter(
          (id) => !subchild.includes(id)
        );
      } else {
        this.expandedIds.push(...childarray);
      }
    },
    hasChildren(item) {
      return item?.children?.length;
    },
    isExpanded(item) {
      let childarray = item.children;
      return this.expandedIds.includes(childarray[0]);
    },
    refreshData() {
      this.getData();
    },
    getData() {
      this.loading = true;
      this.getGLList(this.axios)
        .then((data) => {
          this.data = data;
          this.allgls = data;
          this.getResult = [...data];
          
          // Initialize expanded state for root nodes
          this.getResult.forEach(node => {
            if ((node.parent === "primary" || node.parent === null) && !this.expandedIds.includes(node.code)) {
              this.expandedIds.push(node.code);
            }
          });
          // Also expand 'NA' group if not present
          if (!this.expandedIds.includes("NA")) {
            this.expandedIds.push("NA");
          }

          this.updateOrder();
          this.pendingchange = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    saveData() {
      this.loading = true;
      this.saveGLOrder({ data: this.finalResult, axiosInstance: this.axios })
        .then(() => {
          this.refreshData();
        })
        .catch((err) => {
          this.$store.commit("sbError", err?.message || "Error saving data");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    interchangeposition(k, type, action) {
      if (action === 'down') {
        if (type === 'primary') {
          if (k < ((this.gllist['primary'] || []).length - 1)) {
            let temp = this.gllist['primary'][k];
            this.gllist['primary'][k] = this.gllist['primary'][k + 1];
            this.gllist['primary'][k + 1] = temp;
          }
        } else {
          if (k < ((this.gllist[type] || []).length - 1)) {
            let temp = this.gllist[type][k];
            this.gllist[type][k] = this.gllist[type][k + 1];
            this.gllist[type][k + 1] = temp;
          }
        }
      }
      else if (action === 'up') {
        if (type === 'primary') {
          if (k > 0) {
            let temp = this.gllist['primary'][k];
            this.gllist['primary'][k] = this.gllist['primary'][k - 1];
            this.gllist['primary'][k - 1] = temp;
          }
        } else {
          if (k > 0) {
            let temp = this.gllist[type][k];
            this.gllist[type][k] = this.gllist[type][k - 1];
            this.gllist[type][k - 1] = temp;
          }
        }
      }
      this.pendingchange = true;
      let t = this.gllist;
      this.gllist = {};
      this.gllist = t;

    },
    selectAll() {
      this.selectedgls = this.allgls;
    },
    unSelectAll() {
      this.selectedgls = [];
    },
    getParentListForChange() {
      // Logic for retrieving parent GLs list.
      // Based on original `getParentList` computed property.
      // The goal is to provide options for grouping GLs.
      // The list should probably contain:
      // 1. Primary GLs (from `this.gllist['primary']`)
      // 2. The special 'NA' (Ungrouped) option
      
      let list = [];
      
      // Ensure we have data in gllist['primary']
      if (this.gllist && this.gllist['primary']) {
        list = [...this.gllist['primary']];
      } else {
        // Fallback: Try to reconstruct from allgls if gllist is empty?
        // Or assume gllist is populated correctly.
        // If gllist is empty, let's try to filter primary nodes from allgls
        list = this.allgls.filter(g => g.parent === 'primary' || !g.parent);
      }

      list.push({ 
          code: "NA", 
          name: "Ungrouped: Other sub-schedules and further Analysis Accounts" 
      });

      // Map to dropdown format {text, value}
      return list.map(item => ({
        text: `${item.code} - ${item.name}`,
        value: item.code
      }));
    },
    reorder(dt, key) {
      return dt.sort(function (a, b) { return a[key] - b[key]; });
    }
  },
  computed: {
    visibleItems() {
      return this.flattenTree(this.getResult).filter((item) =>
        this.expandedIds.includes(item.code)
      );
    },
    getParentList: {
      get() {
        let dt = [...this.gllist['primary'] || []];
        // if(!this.isNewList){
        //   dt = [...dt, ...(this.gllist['new'] || [])];
        // }
        dt.push({ code: "NA", name: "Ungrouped: Other sub-schedules and further Analysis Accounts" })
        return dt;
      },
      cache: false
    },
  }

}
</script>

<style scoped>
transition-list * {
  transition: all 0.5s ease-in-out;
}

.all-height {
  height: 95%;
}
.node-container {
  height: 50px;
  margin-right: 5px;
}
.node-label {
  top: 0;
  bottom: 0;
  left: 8px;
  /* width: 1px; */
  /* background-color: #000000; */
  display: block;
  /* Important for visibility */
  height: 100%;
  /* Make sure it stretches */
  content: "";
}

.childlevele-0 {
  width: 0.5px;
  background-color: #383838;
}
.childlevele-1 {
  width: 0.5px;
  background-color: #505050;
}
.childlevele-2 {
  width: 0.5px;
  background-color: #696969;
}
.childlevele-3 {
  width: 0.5px;
  background-color: #808080;
}
.childlevele-4 {
  width: 0.5px;
  background-color: #989898;
}
.childlevele-5 {
  width: 0.5px;
  background-color: #b8b8b8;
}
.childlevele-6 {
  width: 0.5px;
  background-color: #c0c0c0;
}
.childlevele-7 {
  width: 0.5px;
  background-color: #d0d0d0;
}
.childlevele-8 {
  width: 0.5px;
  background-color: #888888;
}
.v-table-color {
  margin-bottom: 50px;
}
</style>